








import { Vue, Component } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter/index.vue";

@Component({
  name: "Index",
  components: {
    CHeader,
    CFooter
  }
})
export default class Index extends Vue {}
